module.exports = __webpack_public_path__ + "static/media/mobileProduct1.19c5b49e.svg";